import { useNavigate } from 'react-router-dom'

export default function RedirectAfterMagicLink() {
    const navigate = useNavigate()

    // Client side redirect to home
    navigate('/')

    return null
}
